<!--this section is specific to pass code page and will show warning message as pass code returned -- invalid-->

<div class="row justify-content-center" *ngIf="warningBannerFlag">
  <div class="col-12 col-sm-10 col-md-6 error-main-container px-0">
    <huk-alert borderradius="soft" colorpalette="warning">
        <span class="fs-5 fw-bold">{{ bannerContent.header }}</span>
      <div class="w-100 wrong-code" [innerHTML]="bannerContent.message"></div>
    </huk-alert>
  </div>
</div>
<div class="row justify-content-center">
  <div class="col-12 content-layout">
      <div class="card-body-container">
        <ng-content></ng-content>
      </div>
  </div>
</div>